import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-white shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-108">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-109">
        <a href="#home" className="flex items-center gap-2 z-50" data-id="element-110">
          <img src="https://cdn.magicpatterns.com/uploads/5SrFpE89xbZUevWfBMF76a/kbella_logo.webp" alt="K'Bella Spa & Wellness" className={`h-10 md:h-12 transition-all duration-300 ${!isScrolled && 'brightness-0 invert'}`} data-id="element-111" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-112">
          <ul className="flex items-center gap-6" data-id="element-113">
            {navLinks.map(link => <li key={link.name} data-id="element-114">
                <a href={link.href} className={`text-sm tracking-wide uppercase font-semibold transition-colors hover:text-brand-teal ${isScrolled ? 'text-brand-charcoal' : 'text-white'}`} data-id="element-115">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <div className="flex items-center gap-4" data-id="element-116">
            <a href="tel:5202338576" className={`font-semibold ${isScrolled ? 'text-brand-charcoal' : 'text-white'} hover:text-brand-teal transition-colors`} data-id="element-117">
              (520) 233-8576
            </a>
            <a href="#contact" className="bg-brand-teal text-white px-6 py-2.5 rounded-sm font-semibold hover:bg-teal-500 transition-colors" data-id="element-118">
              Book Now
            </a>
          </div>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className={`md:hidden z-50 p-2 ${isScrolled || isMobileMenuOpen ? 'text-brand-charcoal' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-119">
          {isMobileMenuOpen ? <X size={28} data-id="element-120" /> : <Menu size={28} data-id="element-121" />}
        </button>

        {/* Mobile Nav */}
        <div className={`fixed inset-0 bg-brand-white z-40 flex flex-col items-center justify-center transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'} md:hidden`} data-id="element-122">
          <ul className="flex flex-col items-center gap-6 mb-8" data-id="element-123">
            {navLinks.map(link => <li key={link.name} data-id="element-124">
                <a href={link.href} className="text-2xl font-heading text-brand-charcoal hover:text-brand-teal transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-125">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="tel:5202338576" className="text-xl font-semibold text-brand-charcoal mb-6" data-id="element-126">
            (520) 233-8576
          </a>
          <a href="#contact" className="bg-brand-teal text-white px-8 py-4 rounded-sm font-semibold text-lg w-[80%] text-center hover:bg-teal-500 transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-127">
            Book Now
          </a>
        </div>
      </div>
    </header>;
}